<template>

<div>
   <b-navbar toggleable  class="header">
     <div class="container">
        <b-navbar-toggle target="nav_text_collapse">
          <i class="material-icons">menu</i>
        </b-navbar-toggle>

        <b-navbar-brand>

          <router-link :to="{name:'dashboard'}" class="navbar-brand">
            <img src="../assets/logo.png" class="logo">
          </router-link>
        </b-navbar-brand>


        <b-collapse is-nav id="nav_text_collapse">
            <b-navbar-nav>


                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'dashboard'}">{{$t('header.dashboard')}}</router-link>
                </li>


                <li class="nav-item">
                <b-dropdown id="" text="Administación" class="m-md-2 box-dropdown"  v-can="'administration.buy.index'">

                  <b-dropdown-item :to="{name:'approvePurchase'}"  v-can="'administration.buy.index'">Administar Compras</b-dropdown-item>

                  <b-dropdown-item :to="{name:'approveConsignment'}" v-can="'administration.consigment.index'" >Administar Consignaciones</b-dropdown-item>

                  <b-dropdown-item :to="{name:'companies'}" v-can="'administration.company.index'" >Empresas</b-dropdown-item>

                  <b-dropdown-item :to="{name:'users'}" v-can="'administration.user.index'">Usuarios</b-dropdown-item>


                  <!--b-dropdown-item :to="{name:'debt'}" >Cartera</b-dropdown-item-->
                  <b-dropdown-item v-b-modal.uploadFileModal v-can="'administration.uploadFile'">Subir Archivos</b-dropdown-item>
                  
                </b-dropdown>
                </li>

                <li class="nav-item">
                <b-dropdown id="" text="Reportes" class="m-md-2 box-dropdown">

                  <b-dropdown-item :to="{name:'resumen'}">Extracto</b-dropdown-item>
                  <b-dropdown-item :to="{name:'balanceBanks'}" v-can="'report.balanceBank'">Saldo en bancos</b-dropdown-item>
                  
                </b-dropdown>
                </li>
                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'consignment'}" v-can="'consignment.index'">{{$t('header.consignment')}}</router-link>
                </li>

                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'buy'}" v-can="'buy.index'">{{$t('header.buy')}}</router-link>
                </li>

                <li class="nav-item ">
                  <router-link class="nav-link" :to="{name:'api'}">{{$t('header.api')}}</router-link>
                </li>

              
            </b-navbar-nav>
            </b-collapse>
          
            <div class="navbar-text">

              <template v-if="user">
                <div class="balance">
                  ${{money(user.balance)}}
                </div>

                <li class="nav-item btn ">
                <b-dropdown id="" text="Configuraciones" class="m-md-2 box-dropdown"  v-can="'administration.buy.index'">

                  <b-dropdown-item :to="{name:'configs'}"  v-can="'administration.buy.index'">
                    
                    Configuraciones
                  </b-dropdown-item>

                  <b-dropdown-item v-b-modal.changePassword v-can="'administration.consigment.index'" >Cambiar contraseña</b-dropdown-item>

                </b-dropdown>
                </li>

                <a class="btn btn-sm btn-space btn-secondary" v-on:click="logout">{{$t('header.logout')}}</a>
              </template>
                            
                <template v-else>
                    <router-link to="login" class="btn  btn-space btn-sm btn-primary">Login</router-link>

                </template>

                <template v-if="$i18n.locale == 'es'">
                   <button @click="$i18n.locale = 'en'" class="btn btn-lang btn-sm btn-lang">EN</button>
                </template>
                <template v-else>
                   <button @click="$i18n.locale = 'es'" class="btn btn-lang btn-sm btn-lang">ES</button>
                </template>

                
            </div>
       </div>
          
    </b-navbar>


    <b-modal id="uploadFileModal" ref="uploadFileModal" title="Subir archivos" hide-footer>
      <form v-on:submit.prevent="upload" ref="uploadFileForm">
        <div class="form-group">
          <select class="form-control" name="bankId" v-on:change="selBank">
            <option>Seleccione un banco</option>
            <option v-for="(bank, index) in banks" :key="index" :value="bank.id">{{bank.name}}</option>
          </select>
        </div>

        <template v-if="curBank.id">
            
            <div>
              <img :src="'/banks/'+curBank.image" class="bankFile">
            </div>

            <div class="form-group">
              <input type="file" name="file">
            </div>

            <button class="btn btn-primary">
              
              <template v-if="!uploading">
                Subir archivo
              </template>
              <template v-else>
                Subiendo..
              </template>
            </button>
        </template>

        

        
      </form>
    </b-modal>

    <b-modal id="changePassword" ref="changePassword" title="Cambiar contraseña" @ok="changePass()">
    <form v-on:submit.prevent="">


     <div class="form-group">
        <label>Contraseña actual</label>
        <input type="password" class="form-control" v-model="change.password">
      </div> 

      <div class="form-group">
        <label>Nueva contraseña</label>
        <input type="password" class="form-control" v-model="change.newPassword">
      </div>      

      <div class="form-group">
          <label class='control-label'>Repetir contraseña</label>
          <input type="password" class="form-control" v-model="change.verifyPassword"> 
      </div>

     
    </form>

  

  </b-modal>

</div>




</template>


<script>
import {
  UPLOAD_FILE,
  FETCH_BANKS,
  CHANGE_PASSWORD
} from "@/store/actions.type";
import { mapGetters } from "vuex";

export default {
  name: "app-header",
  data: function() {
    return {
      curBank: {},
      uploading: false,
      change: {
        password: "",
        verifyPassword: "",
        newPassword: ""
      }
    };
  },
  methods: {
    logout: function() {
      this.$router.replace("/");
    },
    upload: function() {
      if (this.uploading) return;
      this.uploading = true;
      var formData = new FormData(this.$refs.uploadFileForm);
      this.$store
        .dispatch(UPLOAD_FILE, formData)
        .then(result => {
          this.uploading = false;
          this.$refs.uploadFileModal.hide();
          this.$snotify.success(result.message);
        })
        .catch(err => {
          this.uploading = false;
          this.$snotify.error(err.message);
        });
    },
    selBank(e) {
      var value = e.target.value;
      for (var i = this.banks.length - 1; i >= 0; i--) {
        if (this.banks[i].id == value) {
          this.curBank = this.banks[i];
          return;
        }
      }
    },

    changePass() {
      if (!this.change.password) {
        return this.$notify.error("Contraseña obligatoria");
      }

      if (!this.change.newPassword) {
        return this.$notify.error("Nueva contraseña obligatoria");
      }

      if (!this.change.verifyPassword) {
        return this.$notify.error("Verificar contraseña obligatoria");
      }

      this.$store
        .dispatch(CHANGE_PASSWORD, this.change)
        .then(result => {
          this.change = {};
          this.$refs.changePassword.hide();
          this.$snotify.success(result.message);
        })
        .catch(error => {
          this.$snotify.error(error.message);
        });
    }
  },
  mounted() {
    this.$store.dispatch(FETCH_BANKS);
  },

  computed: {
    ...mapGetters(["user", "banks"])
  }
};
</script>


<style lang="scss">
.bankFile {
  width: 200px;
  height: 62px;
  margin: 30px 0;
}
</style>
